import { COMPANY_LOS_ACTIONS } from "../constants";

export function fetchCreateInvoiceJob(requestId, seller, invoiceFiles) {
    return {
        type: COMPANY_LOS_ACTIONS.FETCH_CREATE_INVOICE_JOB,
        payload: {
            requestId,
            seller,
            invoiceFiles
        }
    };
}

export function fetchedCreateInvoiceJob(requestId, response) {
    return {
        type: COMPANY_LOS_ACTIONS.FETCHED_CREATE_INVOICE_JOB,
        payload: {
            requestId,
            response
        }
    };
}

export function failedFetchCreateInvoiceJob(requestId, error) {
    return {
        type: COMPANY_LOS_ACTIONS.FAILED_FETCH_CREATE_INVOICE_JOB,
        payload: {
            requestId
        },
        error
    };
}

export function updateInvoiceJobStatus(requestId, jobId, invoices, totalParsedInvoices) {
    return {
        type: COMPANY_LOS_ACTIONS.UPDATE_INVOICE_JOB_STATUS,
        payload: {
            requestId,
            jobId,
            invoices,
            totalParsedInvoices
        }
    };
}

export function fetchInvoiceJob(jobId) {
    return {
        type: COMPANY_LOS_ACTIONS.FETCH_INVOICE_JOB,
        payload: {
            jobId
        }
    };
}
export function fetchedInvoiceJob(jobId, invoices) {
    return {
        type: COMPANY_LOS_ACTIONS.FETCHED_INVOICE_JOB,
        payload: {
            jobId,
            invoices
        }
    };
}
export function failedFetchInvoiceJob(jobId, error) {
    return {
        type: COMPANY_LOS_ACTIONS.FAILED_FETCH_INVOICE_JOB,
        payload: {
            jobId
        },
        error
    };
}

export function clearInvoiceJob(jobId) {
    return {
        type: COMPANY_LOS_ACTIONS.CLEAR_INVOICE_JOB,
        payload: {
            jobId
        }
    };
}

export function fetchUpdateInvoiceJob(
    jobId,
    invoices,
    type,
    isFinalSubmission
) {
    return {
        type: COMPANY_LOS_ACTIONS.FETCH_UPDATE_INVOICE_JOB,
        payload: {
            jobId,
            invoices,
            type,
            isFinalSubmission
        }
    };
}
export function fetchedUpdateInvoiceJob(jobId, response) {
    return {
        type: COMPANY_LOS_ACTIONS.FETCHED_UPDATE_INVOICE_JOB,
        payload: {
            jobId,
            response
        }
    };
}
export function failedFetchUpdateInvoiceJob(jobId, error) {
    return {
        type: COMPANY_LOS_ACTIONS.FAILED_FETCH_UPDATE_INVOICE_JOB,
        payload: {
            jobId
        },
        error
    };
}
export function clearUpdateInvoiceJob() {
    return {
        type: COMPANY_LOS_ACTIONS.CLEAR_UPDATE_INVOICE_JOB,
    };
}

export function fetchAllInvoiceJob(search, status, page) {
    return {
        type: COMPANY_LOS_ACTIONS.FETCH_ALL_INVOICE_JOB,
        payload: {
            search,
            status,
            page
        }
    };
}
export function fetchedAllInvoiceJob(jobs, page) {
    return {
        type: COMPANY_LOS_ACTIONS.FETCHED_ALL_INVOICE_JOB,
        payload: {
            jobs,
            page
        }
    };
}
export function failedFetchAllInvoiceJob(error) {
    return {
        type: COMPANY_LOS_ACTIONS.FAILED_FETCH_ALL_INVOICE_JOB,
        error
    };
}

export function fetchInvoiceCards() {
    return {
        type: COMPANY_LOS_ACTIONS.FETCH_INVOICE_CARDS,
    };
}
export function fetchedInvoiceCards(count) {
    return {
        type: COMPANY_LOS_ACTIONS.FETCHED_INVOICE_CARDS,
        payload: {
            count
        }
    };
}
export function failedFetchInvoiceCards(error) {
    return {
        type: COMPANY_LOS_ACTIONS.FAILED_FETCH_INVOICE_CARDS,
        error
    };
}

export function fetchMarkJobPending(jobId) {
    return {
        type: COMPANY_LOS_ACTIONS.FETCH_MARK_JOB_PENDING,
        payload: {
            jobId
        }
    };
}
export function fetchedMarkJobPending(job) {
    return {
        type: COMPANY_LOS_ACTIONS.FETCHED_MARK_JOB_PENDING,
        payload: {
            job
        }
    };
}
export function failedFetchMarkJobPending(error) {
    return {
        type: COMPANY_LOS_ACTIONS.FAILED_FETCH_MARK_JOB_PENDING,
        error
    };
}

export function fetchFinalSubmission(jobId, type) {
    return {
        type: COMPANY_LOS_ACTIONS.FETCH_FINAL_SUBMISSION,
        payload: {
            jobId,
            type
        }
    };
}
export function fetchedFinalSubmission(jobId, type, response) {
    return {
        type: COMPANY_LOS_ACTIONS.FETCHED_FINAL_SUBMISSION,
        payload: {
            jobId,
            type,
            response
        }
    };
}
export function failedFinalSubmission(error) {
    return {
        type: COMPANY_LOS_ACTIONS.FAILED_FETCH_FINAL_SUBMISSION,
        error
    };
}

export function fetchRemoveInvoice(jobId, invoiceId, remainingInvoices, isFinal) {
    return {
        type: COMPANY_LOS_ACTIONS.FETCH_REMOVE_INVOICE,
        payload: {
            jobId,
            invoiceId,
            remainingInvoices,
            isFinal
        }
    };
}
export function fetchedRemoveInvoice(jobId, remainingInvoices) {
    return {
        type: COMPANY_LOS_ACTIONS.FETCHED_REMOVE_INVOICE,
        payload: {
            jobId,
            remainingInvoices,
        }
    };
}
export function failedRemoveInvoice(jobId, error) {
    return {
        type: COMPANY_LOS_ACTIONS.FAILED_FETCH_REMOVE_INVOICE,
        payload: {
            jobId
        },
        error
    };
}

export function fetchDealerFromGstin(gstin) {
    return {
        type: COMPANY_LOS_ACTIONS.FETCH_DEALERS_FROM_GSTIN,
        payload: {
            gstin
        }
    };
}
export function fetchedDealerFromGstin(response) {
    return {
        type: COMPANY_LOS_ACTIONS.FETCHED_DEALERS_FROM_GSTIN,
        payload: {
            response,
        }
    };
}
export function failedFetchDealerFromGstin(error) {
    return {
        type: COMPANY_LOS_ACTIONS.FAILED_FETCH_DEALERS_FROM_GSTIN,
        error
    };
}